// frontend/src/pages/Login.js — Session 18
// + toggle afficher/masquer MDP  + lien "Mot de passe oublié"
import { useSearchParams } from 'react-router-dom';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../utils/AuthContext';
import logo from '../assets/logo_original.png';
import theme from '../theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Login = () => {
  const [searchParams]            = useSearchParams();
  const prefillEmail              = searchParams.get('email') || '';
  const refParam                  = searchParams.get('ref')   || '';

  const [formData, setFormData]   = useState({
    email:          prefillEmail,
    mot_de_passe:   '',
  });
  const [showPwd,  setShowPwd]    = useState(false);
  const [error,    setError]      = useState('');
  const [loading,  setLoading]    = useState(false);
  const { login }                 = useAuth();
  const navigate                  = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const response = await axios.post(`${API_URL}/auth/login`, formData);
      login(response.data.token, response.data.data);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        <div style={styles.header}>
          <img src={logo} alt="MKW Solutions" style={styles.logo} />
          <p style={styles.subtitle}>Espace de gestion — Devis &amp; Factures</p>
        </div>

        <h2 style={styles.title}>Connexion</h2>

        {error && <div style={styles.errorBox}>⚠️ {error}</div>}

        
      {/* Banner redirect depuis vitrine */}
      {refParam === 'devis' && prefillEmail && (
        <div style={{
          background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 12,
          padding: '12px 16px', marginBottom: 20, display: 'flex', gap: 10, alignItems: 'flex-start',
        }}>
          <span style={{ fontSize: 18 }}>💬</span>
          <div>
            <p style={{ margin: 0, fontWeight: 700, fontSize: 13, color: '#1e40af' }}>
              Compte existant détecté
            </p>
            <p style={{ margin: '4px 0 0', fontSize: 12, color: '#3b82f6' }}>
              Connectez-vous pour finaliser votre demande de devis. Votre email a été pré-rempli.
            </p>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Adresse email</label>
            <input
              type="email" name="email"
              value={formData.email} onChange={handleChange}
              required placeholder="votre@email.com"
              style={styles.input}
            />
          </div>

          <div style={styles.fieldGroup}>
            <label style={styles.label}>Mot de passe</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPwd ? 'text' : 'password'}
                name="mot_de_passe"
                value={formData.mot_de_passe} onChange={handleChange}
                required placeholder="••••••••"
                style={{ ...styles.input, paddingRight: '44px', width: '100%', boxSizing: 'border-box' }}
              />
              <button type="button" onClick={() => setShowPwd(v => !v)} style={styles.eyeBtn}
                title={showPwd ? 'Masquer' : 'Afficher'}>
                {showPwd ? '🙈' : '👁'}
              </button>
            </div>
          </div>

          {/* Lien mot de passe oublié */}
          <div style={{ textAlign: 'right', marginTop: '-8px' }}>
            <Link to="/forgot-password" style={styles.forgotLink}>
              Mot de passe oublié ?
            </Link>
          </div>

          <button type="submit" disabled={loading} style={{
            ...styles.submitBtn,
            opacity: loading ? 0.7 : 1,
            cursor:  loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? '⏳ Connexion…' : '🔐 Se connecter'}
          </button>
        </form>

        <div style={styles.registerLink}>
          Pas encore de compte ?{' '}
          <Link to="/register" style={{ color: theme.primary, fontWeight: '600' }}>
            S'inscrire
          </Link>
        </div>

        <div style={styles.legal}>
          © {new Date().getFullYear()} MKW Solutions · Tous droits réservés
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: theme.gradientPage || `linear-gradient(135deg, #f0f4f8 0%, #dce8f0 100%)`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '20px',
  },
  card: {
    background: 'white', borderRadius: '16px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
    padding: '40px 36px', width: '100%', maxWidth: '420px',
  },
  header: {
    textAlign: 'center', marginBottom: '28px',
    paddingBottom: '20px', borderBottom: `1px solid ${theme.border}`,
  },
  logo: { width: '200px', height: 'auto', borderRadius: '8px', marginBottom: '12px' },
  subtitle: { margin: 0, color: theme.textSecondary, fontSize: '13px' },
  title: { margin: '0 0 20px 0', color: theme.textPrimary, fontSize: '20px', fontWeight: '700' },
  errorBox: {
    background: theme.dangerBg, color: theme.danger,
    border: `1px solid ${theme.dangerBorder}`,
    borderRadius: '8px', padding: '12px 16px',
    marginBottom: '16px', fontSize: '14px',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '14px', fontWeight: '500', color: theme.textPrimary },
  input: {
    padding: '11px 14px', border: `1px solid ${theme.border}`,
    borderRadius: '8px', fontSize: '14px', outline: 'none',
    transition: 'border-color 0.15s', color: theme.textPrimary,
    display: 'block',
  },
  eyeBtn: {
    position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: '18px', lineHeight: 1, padding: '2px',
  },
  submitBtn: {
    padding: '13px', background: theme.gradientPrimary,
    color: 'white', border: 'none', borderRadius: '8px',
    fontSize: '15px', fontWeight: '600', marginTop: '4px',
    transition: 'opacity 0.15s', width: '100%',
  },
  forgotLink: { color: theme.primary, fontSize: '13px', textDecoration: 'none', fontWeight: '500' },
  registerLink: { textAlign: 'center', marginTop: '20px', fontSize: '14px', color: theme.textSecondary },
  legal: {
    textAlign: 'center', marginTop: '24px', fontSize: '11px',
    color: theme.textMuted, borderTop: `1px solid ${theme.border}`, paddingTop: '16px',
  },
};

export default Login;
